<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_about flex-col">
                <my-menu class="sticky-menu" :default-active-index="1"></my-menu>
                <div class="block_52 flex-col">
                    <div class="section_5 flex-col" :style="{ backgroundImage: `url(${aboutBanner})` }">
                        <div class="text-wrapper_3">
                            <span class="text_9">愿景</span>
                            <span class="text_10">—致力成为全球化商业组织的健康管理专家</span>
                        </div>
                        <div class="text-wrapper_4">
                            <span class="text_11">使命</span>
                            <span class="text_12">—助力企业实现可持续发展</span>
                        </div>
                    </div>
                </div>
                <div class="div_content">
                    <div class="section_introduce flex-col" id="introduce-section">
                        <div class="text-wrapper_119 flex-row"><span class="text_8">康柏简介</span></div>
                        <div class="image-wrapper_14 flex-row">
                            <img
                                    class="image_2"
                                    referrerpolicy="no-referrer"
                                    src="../../assets/home/chpc_about_line_01.png"
                            />
                        </div>
                        <div class="block_53 flex-row">
                            <div class="image-text_181 flex-row">
                                <div class="image-text_182 flex-row">
                                    <div class="image-text_183 flex-row justify-between">
                                        <div class="block_7 flex-col"></div>
                                        <span class="paragraph_1">
                              康柏汉森深耕医药行业近二十年，是大健康领域风险控制服务的倡导者与实践者，作为值得信赖的风控合规合作伙伴，我们依托北京、上海、广州等10大运营中心，&nbsp;数十位资深项目经理与数百位专业核查团队，为大健康领域100余家全球领先企业提供全链路风控与合规管理服务。
                              <br />
                              <br />
                              康柏汉森拥有企业健康管理智慧中心，通过AI人工智能工具集、多源数据交叉验证系统及合规风险评估模型等，精准识别销售舞弊、渠道窜货及供应链合规隐患。聚焦外资企业本土化合规痛点，为企业提供定制化解决方案。&nbsp;
                              <br />
                              <br />
                              康柏汉森专注于企业风险诊断与合规管理，深刻理解企业经营健康与业务成长的迫切需求，为企业提供业务风控与合规管理的多样化产品以及整体服务解决方案，助力客户达成“风险可视、决策可依、增长可持续”。
                            </span>
                                    </div>
                                    <div class="block_8 flex-col"></div>
                                </div>
                                <div class="box_2 flex-col"></div>
                            </div>
                            <div class="group_77-container">
                                <div class="group_77 flex-col" :style="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
                            </div>

                        </div>
                    </div>
                    <ChpcValues :backgroundImagesProp="backgroundImagesProp"></ChpcValues>
                    <!--康柏汉森-->
                    <div class="hcpc_about_01 flex-row" >
                        <div class="image-text_186 flex-row justify-between">
                            <div class="group_4 flex-col"></div>
                            <span class="paragraph_2">
                        康柏汉森始终致力于成为客户心中靠谱的战略合作伙伴，始终坚持“担当、诚信、专业、合作”的价值观，始终秉承靠谱的做事态度。
                        <br />
                        <br />
                        靠谱精神是对承诺的坚守、对专业的追求、对客户的尊重以及对结果的执着，秉承靠谱精神，康柏人将继续为客户提供值得信赖的服务。
                      </span>
                        </div>
                        <div class="block_18 flex-col"></div>
                    </div>
                    <!--企业荣誉-->
                    <div class="block_honor flex-col" id="honor-section">
                        <div class="box_6 flex-col">
                            <div class="group_106 flex-row">
                                <div class="text-group_220 flex-col justify-between">
                                    <span class="text_27">企业荣誉</span>
                                    <span class="text_28">CORPORATE&nbsp;HONORS</span>
                                </div>
                            </div>
                            <div class="group_107 flex-row justify-between">
                                <div class="box_94 flex-col justify-between">
                                    <div class="section_50_m4 flex-row section_honor_row">
                                        <div class="block_20 flex-row">
                                            <div class="image-text_187 flex-col justify-between">
                                                <img
                                                        class="image_8"
                                                        referrerpolicy="no-referrer"
                                                        src="../../assets/index/chpc_index_honor10.png"
                                                />
                                                <div class="text-group_221 flex-col justify-between">
                                                    <span class="text_29">信息安全管理体系认证证书</span>
                                                    <span class="text_30">ISO&nbsp;27001</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="block_21 flex-row">
                                            <div class="image-text_188 flex-col justify-between">
                                                <img
                                                        class="image_9"
                                                        referrerpolicy="no-referrer"
                                                        src="../../assets/index/chpc_index_honor10.png"
                                                />
                                                <div class="text-group_222 flex-col justify-between">
                                                    <span class="text_31">质量管理体系认证证书</span>
                                                    <span class="text_32">ISO&nbsp;9001</span>
                                                </div>
                                            </div>
                                        </div>
                                        <!--
                                        <div class="block_22 flex-row">
                                            <div class="image-text_189 flex-col justify-between">
                                                <div class="image-wrapper_2 flex-col">
                                                    <img
                                                            class="image_10"
                                                            referrerpolicy="no-referrer"
                                                            src="../../assets/index/chpc_index_honor9.png"
                                                    />
                                                </div>
                                                <div class="text-group_223 flex-col justify-between">
                                                    <span class="text_33">多元化供应商</span>
                                                    <span class="text_34">MSD&nbsp;China</span>
                                                </div>
                                            </div>
                                        </div>
                                        -->
                                        <div class="block_24 flex-row">
                                            <div class="image-text_192 flex-col justify-between">
                                                <div class="image-wrapper_4 flex-col">
                                                    <img
                                                            class="image_13"
                                                            referrerpolicy="no-referrer"
                                                            src="../../assets/index/chpc_index_honor8.png"
                                                    />
                                                </div>
                                                <div class="text-group_226 flex-col justify-between">
                                                    <span class="text_38">已进行科学碳目标设定</span>
                                                    <span class="text-wrapper_5">SBTi</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="block_26 flex-col">
                                            <img
                                                    class="image_14"
                                                    referrerpolicy="no-referrer"
                                                    src="../../assets/index/chpc_index_honor4.png"
                                            />
                                            <div class="text-group_228 flex-col justify-between">
                                                <span class="text_43">&nbsp;24-25获气候问卷B级</span>
                                                <span class="text_44">CDP</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section_51_m3 flex-row justify-between">
                                        <div class="box_7 flex-row">
                                            <div class="image-text_190 flex-col justify-between">
                                                <img
                                                        class="image_11"
                                                        referrerpolicy="no-referrer"
                                                        src="../../assets/index/chpc_index_honor7.png"
                                                />
                                                <div class="text-group_227 flex-col justify-between">
                                                    <span class="text_41">企业社会责任认证单位</span>
                                                    <span class="text_36">EcoVdis</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="box_8 flex-row">
                                            <div class="image-text_191 flex-col justify-between">
                                                <div class="image-wrapper_3 flex-col">
                                                    <img
                                                            class="image_12"
                                                            referrerpolicy="no-referrer"
                                                            src="../../assets/index/chpc_index_honor6.png"
                                                    />
                                                </div>
                                                <div class="text-group_225 flex-col justify-between">
                                                    <span class="text_37">多项自研技术专利</span>
                                                    <span class="paragraph_3">
                                  Patent
                                  <br />
                                </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="box_8 flex-row">
                                            <div class="image-text_193 flex-col justify-between">
                                                <img
                                                        class="image_44"
                                                        referrerpolicy="no-referrer"
                                                        src="../../assets/index/chpc_index_honor5.png"
                                                />
                                                <div class="text-group_227 flex-col justify-between">
                                                    <span class="text_41">多个行业委员会成员企业</span>
                                                    <span class="text_42">ASSOCIATION</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div id="server-section">
                        <ServerGood></ServerGood>
                    </div>

                    <div id="value-section">
                        <industry-value ></industry-value>
                    </div>

                </div>
                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
            </div>
        </div>
        <div class="mobile-element">
            <div class="mobile-page flex-col">
                <mobile-header class="sticky-menu-mobile" :default-active-index="1"></mobile-header>
                <div class="mobile-link">
                    <mobile-link :default-active-index="1"></mobile-link>
                    <mobile-banner :contactBanner="aboutBanner"></mobile-banner>
                    <!--
                    <div class="block_52 flex-col">
                        <div class="section_mobile_banner flex-col" :style="{ backgroundImage: `url(${aboutBanner})` }">
                            <div class="text-wrapper_3_mobile">
                                <span class="text_9_mobile">愿景</span>
                                <span class="text_10_mobile">—致力成为全球化商业组织的健康管理专家</span>
                            </div>
                            <div class="text-wrapper_4_mobile">
                                <span class="text_9_mobile">使命</span>
                                <span class="text_10_mobile">—助力企业实现可持续发展</span>
                            </div>
                        </div>
                    </div>
                    -->
                    <div class="div_content_mobile">
                        <div style="margin-top: 2px;" id="introduce-section2">
                            <mobile-about></mobile-about>
                        </div>
                        <mobile-value></mobile-value>
                        <div class="outer-container">
                            <div class="cotent_my_value flex-col">
                                <div class="chpc-value-div flex-row justify-between">
                                    <div class="paragraph_container">
                                        <div class="paragraph_block">
                                            <div class="point_line1 flex-col"></div>
                                            <span class="span_chpc_value">
                                                康柏汉森始终致力于成为客户心中靠谱的战略合作伙伴，始终坚持“担当、诚信、专业、合作”的价值观，始终秉承靠谱的做事态度。</span>
                                        </div>
                                        <div class="paragraph_block">
                                            <div class="point_line1 flex-col"></div>
                                            <span class="span_chpc_value">靠谱精神是对承诺的坚守、对专业的追求、对客户的尊重以及对结果的执着，秉承靠谱精神，康柏人将继续为客户提供值得信赖的服务。</span>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <!--mobile honor-->
                        <mobile-honor id="honor-section2"></mobile-honor>
                        <mobile-server id="server-section2"></mobile-server>
                        <mobile-industry id="value-section2"></mobile-industry>

                    </div>
                </div>
                <mobile-footer @contactMobile="contactMobile"></mobile-footer>
                <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

            </div>
        </div>
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ChpcValues from "@/views/Component/ChpcValues";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import ServerGood from "./childPage/ServerGood";
    import IndustryValue from "./childPage/IndustryValue";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileBanner from "./childPage/MobileBanner";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileValue from "@/views/Component/MobileValue";
    import MobileHonor from "@/views/Component/MobileHonor";
    import MobileAbout from "./childPage/MobileAbout";
    import MobileServer from "./childPage/MobileServer";
    import MobileIndustry from "./childPage/MobileIndustry";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import {isNull} from "../../common/testFun";
    import commonFun from "@/util/common.js";

    export default {
        name: "aboutIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司-联系我们',
            meta:[{name: 'keyWords', content:'北京总公司,上海分公司,武汉办事处，广州办事处，南京办事处，成都办事处，天津办事处，官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"康柏分公司，康柏办事处，北京总公司,上海分公司,武汉办事处，广州办事处，南京办事处，成都办事处，天津办事处，官网，中国医药行业内风险控制领域的服务提供商"},
                {name:"robots",content:"北京康柏汉森医，走进康柏"},
            ]
        },
        data() {
            return {
                isVisible:true,
                isVisibleMobile:false,
                aboutBanner: require('@/assets/home/about_banner.png'),
                imageUrl: require('@/assets/home/chpc_about_01.png'),

                backgroundImagesProp: {
                    group_10: require('../../assets/home/home_my_value_01.png'),
                    group_11: require('../../assets/home/home_my_value_02.png'),
                    group_12: require('../../assets/home/home_my_value_03.png'),
                    group_14: require('../../assets/home/home_my_value_04.png'),
                },
            };
        },
        //
        components:{
            myMenu,ContactFloat,ChpcFooter,ChpcValues,ServerGood,IndustryValue,ContactDialog,
            MobileHeader,MobileLink,MobileFooter,MobileAbout,MobileServer,MobileIndustry,
            MobileValue,MobileHonor,MobileContactDialog,MobileBanner
        },
        mounted() {
            this.getPic();
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            getPic(){
                let pic ={model:2}
                this.$HTTP.getPicByModel(pic).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        if(data && data.length>0){
                            let picarr= commonFun.dealPic(data,1,false);
                            if(picarr && picarr.length>0){
                                this.aboutBanner = picarr;
                            }
                            let aboutImg = commonFun.dealPic(data,2,false);
                            if(!isNull(aboutImg)){
                                this.imageUrl = aboutImg;
                            }
                        }
                    }
                });
            }
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
<style scoped>
    .section_honor_row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;   /* 关键：水平等间距，且整体居中 */
        align-items: center;             /* 垂直居中 */
        width: 100%;
    }

    /* 清除子块可能自带的左右 margin，避免间距不均 */
    .section_honor_row > .block_20,
    .section_honor_row > .block_21,
    .section_honor_row > .block_24,
    .section_honor_row > .block_26 {
        flex: 0 0 auto;                  /* 不伸缩，宽度由自身内容决定 */
        margin-left: 0;
        margin-right: 0;
    }

    /* ===== 修复：企业社会责任认证单位 显示不全且不居中 ===== */
    .box_7 .text-group_227 {
        width: 240px;          /* 与卡片同宽 */
        margin-left: -60px;    /* 抵消 .image-text_190 的 margin-left: 60px */
    }

    .box_7 .text_41 {
        width: 240px;          /* 文字容器撑满卡片宽度 */
    }

    .box_7 .text_36 {
        width: 240px;
        text-align: center;    /* 覆盖原 margin-left 硬偏移 */
        margin: 9px 0 0 0;
    }

    /* ===== 修复：已进行科学碳目标设定 不居中 ===== */
    .block_24 .text-group_226 {
        width: 240px;
        margin-left: -63px;    /* 抵消 .image-text_192 的 margin-left: 63px */
    }

    .block_24 .text_38 {
        width: 240px;
    }

    .block_24 .text-wrapper_5 {
        width: 240px;
        text-align: center;
        margin: 8px 0 0 0;
    }


</style>
